var fn = function( obj ){
var __t,__p='';
__p+='\nc=c*uContrastScale+uContrastBias;';
return __p;
};
fn.toString=fn;
module.exports = fn;